const palette_custom = {
  primary: "#24375c",
  secondary: "#e7edeb",
  accent: "#ea7c3c",
  text: "#000000",
  background: "#f6f6f6",
  check: "#4674c2",
  error: "#fd7777",
  risk: "#fce59e",
  late: "#fd7777",
  optimal: "#c4dfb4",
  marker: "#577dfa",
  success: "#4caf50",
  neutral: "#adbdda",
};

export default palette_custom;
